module.exports = __webpack_public_path__ + "static/img/moneyroad_purple.1119576.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/logo/moneyroad_purple.svg
// module id = 1485
// module chunks = 2